import React from 'react'
import PropTypes from 'prop-types'

const UserProfile = ({ user }) => (
  <li className='navigation-menu-user-profile'>
    <div className='user-content'>
      <span className='user-name'>
        <strong>{user && user.fullName}</strong>
      </span>
      <span className='user-company'>{user && user.email}</span>
    </div>
  </li>
)

UserProfile.propTypes = {
  user: PropTypes.object.isRequired,
}

export default UserProfile
